module.exports = __webpack_public_path__ + "static/media/thumbs-up.ce26c3a6.svg";